<template>
  <div :class="['container', floor.$style]" @touchstart="onTouchStart">
    <div 
      ref="tabs"
      class="tabs" 
      :style="{ backgroundColor: floor.bgColor, color: floor.fontColor, backgroundImage: `url(${floor.bgImageUrl})` }"
    >
      <div
        :class="['tab', index === tabIndex ? 'active' : '']"
        v-for="(item, index) of floor.items"
        :key="item.id"
        :style="{ marginRight: floor.naviSpacing }" 
        @click="onTabClick(index)">
        <div class="title">{{item.name}}<span class="line" :style="{ backgroundColor: floor.barColor }"></span></div>
        <div class="desc">{{item.secondName}}</div>
      </div>
    </div>
    <van-tabs 
      :swipeable="floor.slipAble === 1"
      :animated="floor.slipAble === 1"
      v-model="tabIndex"
      @change="onSwitchTab"
    >
      <van-tab v-for="(item, index) of floor.items" :key="item.id">
        <div :style="{ minHeight: contentHeight }">
          <floors
            :from="home.$from" 
            :parent="{ tabIndex: index, floor }"
            :activity-id="item.pageLinkValue" 
            @call="e => $emit('call', e)"
          />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import utils from '@/utils/common'
export default {
  components: { Floors: () => import('../index') },
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      show: false,
      tabIndex: 0,
      contentHeight: ''
    }
  },
  created() {
    this.defaultStyle = {
      bgColor: '#FFFFFF',
      fontColor: '#333333',
      barColor: '#F8D541'
    }
    this.init()
  },
  methods: {
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      if(this.unwatch) this.unwatch()
      const { floor } = this
      this.normalizeFloor(floor)
      this.normalizeOldData(floor)
      this.tabIndex = 0
      this.contentHeight = this.computeContentHeight(floor)
      this.unwatch = this.$watch('floor', this.init)
    },
    normalizeOldData(floor) {
      if(floor.isOldData !== 1) return;
      const style  = floor.textNaviStyle || {}
      const d = this.defaultStyle
      floor.$style = 'style-old'
      floor.bgColor = style.bgColor || d.bgColor
      floor.fontColor = style.textColor || d.fontColor
      floor.barColor  = style.indicatorColor || d.barColor
      floor.naviSpacing = utils.rem2px(style.naviSpacing || 0)
    },
    normalizeFloor(floor) {
      floor.naviSpacing = 0
      for(const key in this.defaultStyle) {
        if(!floor[key]) {
          floor[key] = this.defaultStyle[key]
        }
      }
    },
    computeContentHeight(floor) {
      const tabHeight = ({ 'style-one': 100, 'style-two': 92 })[floor.$style]
      return `calc( 100vh - ${utils.rem2px(tabHeight)})`
    },
    onTabClick(index) {
      this.tabIndex = index
    },
    onSwitchTab(index) {
      this.setActive(index)
    },
    setActive(index) {
      this.scrollTo()
    },
    onFloorsLoad() {
      this.$nextTick(() => this.scrollTo())
    },
    onTouchStart() {
      this.lastIndex = this.tabIndex
    },
    scrollTo() {
      const root = this.$root.$el
      const tabs = this.$refs.tabs
      const currentItem = this.floor.items[this.tabIndex]
      const lastItem = this.floor.items[this.lastIndex]
      lastItem.scrollTop = Math.max(root.scrollTop, tabs.offsetTop)
      if(!currentItem.scrollTop) {
        currentItem.scrollTop = tabs.offsetTop
      }
      root.scrollTop = currentItem.scrollTop
    }
  }
}
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  text-align: center;
  font-size: 0;
  position: sticky;
  top: 0;
  z-index: 30;
  background-color: #ffffff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
}
.tab {
  flex: 1;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 10px;
}
.tab .title {
  font-size: 28px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tab .line {
  display: none;
}
.tab .desc {
  max-width: 100%;
  font-size: 20px;
  color: #999999;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: border-box;
}
.style-one .tab {
  padding: 16px 10px;
}
.style-one .tab::after {
  content: " ";
	position: absolute;
	right: 0;
	top: 50%;
  height: 60px;
  margin-top: -30px;
	transform: scale(0.5, 0.5);
  border-right: 1px solid #cccccc;
}
.style-one .tab:last-child::after {
  display: none;
}
.style-one .active .title {
  color: #ED3939;
}
.style-one .active .desc {
  max-width: 100%;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  background-color: #ED3939;
  border-radius: 16px;
  padding: 0 16px;
  color: #ffffff;
}
.style-two .desc {
  display: none;
}
.style-two .tab .title {
  display: inline-block;
  position: relative;
  padding: 26px 0;
}
.style-two .line,
.style-old .line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  height: 6px;
  border-radius: 4px;
}
.style-two .active .line,
.style-old .active .line {
  display: block;
}
.style-old .tabs {
  padding: 0 30px;
  overflow-x: auto;
  overflow-y: hidden;
}
.style-old .desc {
  display: none;
}
.style-old .tab {
  flex: none;
}
.style-old .tab:last-child {
  margin-right: 0!important;
}
.style-old .tab .title {
  padding: 26px 0;
}
.container /deep/.van-tabs__wrap {
  display: none;
}

</style>
